module.exports = "/images/people.svg?87e141bbe817b9c96cdd366fdac3f7ff";